// extracted by mini-css-extract-plugin
module.exports = {"container":"BundleGroupSelection_container__bJXLr","groupWrap":"BundleGroupSelection_groupWrap__11JYv","title":"BundleGroupSelection_title__2GsZ8"};